<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div class="select is-small">
      <select v-model="computedValue">
        <option
          v-for="(item, index) in items"
          :key="index"
          :value="index"
          :selected="index == computedValue"
        >
          {{ item }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import { ref, watch, computed } from 'vue';

export default {
  name: 'Pulldown',
  props: ['defaultValue', 'label', 'items', 'trigger'],
  emits: ['selectupdate'],
  setup(props, { emit }) {
    /*newValue is de middle-man,
    computedValue is de waarde waar het om draait

    todo: Dropdown bulma menu van maken
*/
    const newValue = ref(0);
    const computedValue = computed({
      get: () => {
        return newValue.value;
      },
      set: (value) => {
        newValue.value = value;
        emit('selectupdate', newValue.value);
      },
    });
    watch(
      () => props.defaultValue,
      (val) => {
        newValue.value = val;
      },
      {
        immediate: true,
      }
    );
    watch(
      () => props.trigger,
      () => {
        newValue.value = props.defaultValue;
      },
      {
        immediate: true,
      }
    );
    return {
      computedValue,
    };
  },
};
</script>
